
import { useContext } from "react";
import { UploadContext } from "@/components/common/upload-context";

export const useUploadController = () => {
  const context = useContext(UploadContext);
  if (!context) throw new Error('useUploadContext must be used within UploadProvider');

  return {
    ...context,
  };
};